import React, { useState } from 'react';
import { Modal, Input, message } from 'antd';
import { useNavigate } from 'react-router-dom';

import { api } from 'api';
import { getErrorMessage } from 'helpers/feedbackMessageHelper';

const CreateLeagueModal = ({ open, onClose, onCreated }) => {

    const navigate = useNavigate();

    const [leagueName, setLeagueName] = useState('');
    const [creating, setCreating] = useState(false);

    const handleCreateLeague = async () => {
        setCreating(true);
        try {
            const response = await api.user.createMiniLeague(leagueName);
            onClose();
            setLeagueName('');
            onCreated();
            message.success('League created successfully');
            navigate(`/team-standings/${response.data.id}`);
        } catch (error) {
            const errorMessage = error.response ? error.response.data.error : 'generic';
            message.error(getErrorMessage(errorMessage));
        }
        setCreating(false);
    };

    const handleCancel = () => {
        onClose();
        setLeagueName('');
    };

    return (
        <Modal
            title="Create a League"
            open={open}
            onCancel={handleCancel}
            onOk={handleCreateLeague}
            okText="Create"
            confirmLoading={creating}
            okButtonProps={{ disabled: !leagueName.trim() }}
        >
            <Input
                placeholder="League name"
                value={leagueName}
                onChange={e => setLeagueName(e.target.value)}
                onPressEnter={handleCreateLeague}
            />
        </Modal>
    );
};

export default CreateLeagueModal;
